<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
   data-testid="icons-icon-sk-search-svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6286 6.31429C12.6286 5.06544 12.2582 3.84464 11.5644 2.80626C10.8706 1.76788 9.88444 0.958562 8.73066 0.480649C7.57687 0.00273585 6.30728 -0.122308 5.08243 0.12133C3.85758 0.364968 2.73248 0.966345 1.84941 1.84941C0.966345 2.73248 0.364968 3.85758 0.12133 5.08243C-0.122308 6.30728 0.00273585 7.57687 0.480649 8.73066C0.958562 9.88444 1.76788 10.8706 2.80626 11.5644C3.84464 12.2582 5.06544 12.6286 6.31429 12.6286C7.82069 12.6285 9.27768 12.0912 10.4234 11.1131L10.6857 11.3754V12.1429L14.8357 16.2929C15.2263 16.6834 15.8594 16.6834 16.25 16.2929L16.2929 16.25C16.6834 15.8594 16.6834 15.2263 16.2929 14.8358L12.1429 10.6857H11.3754L11.1131 10.4234C12.0912 9.27768 12.6285 7.82069 12.6286 6.31429ZM1.94205 6.31429C1.94205 3.88572 3.88491 1.94286 6.31348 1.94286C8.74205 1.94286 10.6849 3.88572 10.6849 6.31429C10.6849 8.74286 8.74205 10.6857 6.31348 10.6857C3.88491 10.6857 1.94205 8.74286 1.94205 6.31429Z"
      fill="#828D9B"
    data-testid="icons-icon-sk-search-path" />
  </svg>
</template>